import { Injectable } from '@angular/core';

import {
  CmsService,
  ProtectedRoutesGuard,
  RouteLoadStrategy,
  RoutingConfigService,
  RoutingService,
} from 'haba-core';
import { of } from 'rxjs';
import { first, switchMap, take } from 'rxjs/operators';
import { CmsProductPageGuardService } from '../services/cms-product-page-guard.service';

@Injectable({
  providedIn: 'root',
})
export class HabaCmsProductPageGuard {
  constructor(
    protected routingService: RoutingService,
    protected cmsService: CmsService,
    protected protectedRoutesGuard: ProtectedRoutesGuard,
    protected service: CmsProductPageGuardService,
    protected routingConfig: RoutingConfigService
  ) {}

  canActivate(route, state) {
    return this.protectedRoutesGuard.canActivate(route).pipe(
      switchMap((canActivate) =>
        canActivate === true
          ? this.routingService.getNextPageContext().pipe(
              take(1),
              switchMap((pageContext) =>
                this.cmsService.getPage(pageContext, this.shouldReload()).pipe(
                  first(),
                  switchMap((pageData) => {
                    return pageData
                      ? this.service.canActivateProductPage(pageContext, pageData, route, state)
                      : this.service.canActivateNotFoundPage(pageContext, route, state);
                  })
                )
              )
            )
          : of(canActivate)
      )
    );
  }
  private shouldReload(): boolean {
    return this.routingConfig.getLoadStrategy() !== RouteLoadStrategy.ONCE;
  }
}
